import { render } from "./HelpWindow.vue?vue&type=template&id=2172b082&scoped=true"
import script from "./HelpWindow.vue?vue&type=script&lang=js"
export * from "./HelpWindow.vue?vue&type=script&lang=js"

import "./HelpWindow.vue?vue&type=style&index=0&id=2172b082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2172b082"]])

export default __exports__